import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, EyeIcon, BriefcaseIcon, ShieldIcon, CrownIcon } from 'lucide-react';
const bonuses = [{
  n: '01',
  icon: MessageCircleIcon,
  title: '50 Frases para Responder sin Pelear',
  desc: 'El kit completo de respuestas listas para situaciones tensas. Frases probadas para mantener tu calma sin parecer agresivo.',
  items: ['poner límites', 'responder críticas', 'cortar manipulación', 'manejar conversaciones incómodas'],
  price: '$8.500'
}, {
  n: '02',
  icon: EyeIcon,
  title: 'Cómo Detectar Manipuladores Rápidamente',
  desc: 'Guía visual y práctica para reconocer las tácticas más comunes antes de caer en ellas.',
  items: ['señales', 'patrones', 'tácticas psicológicas', 'frases típicas'],
  price: '$9.000'
}, {
  n: '03',
  icon: BriefcaseIcon,
  title: 'Guía Rápida para Manejar Jefes Difíciles',
  desc: 'Protocolo paso a paso para sobrevivir y prosperar en ambientes laborales tensos. Estrategias específicas para jefes tóxicos.',
  items: ['menos tensión laboral', 'más claridad', 'más control emocional'],
  price: '$8.500'
}, {
  n: '04',
  icon: ShieldIcon,
  title: 'Cómo Dejar de Absorber Problemas Ajenos',
  desc: 'El protocolo de blindaje energético. Cómo escuchar sin cargar el peso emocional de los demás.',
  items: ['agotamiento mental', 'culpa', 'ansiedad emocional', 'protección energética'],
  price: '$8.000'
}];
const premium = {
  icon: CrownIcon,
  title: 'Personalidades Difíciles Explicadas',
  desc: 'El bonus premium del método. Una guía profunda sobre cada tipo de personalidad complicada, con frases típicas, patrones de comportamiento y estrategias específicas para cada una.',
  items: ['manipulador', 'controlador', 'víctima constante', 'agresivo pasivo', 'explosivo', 'competitivo tóxico'],
  price: '$12.000'
};
export function BonusSection() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-19">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-20">
            <span className="text-xs font-bold tracking-widest" data-id="element-21">
              🎁 5 BONUS INCLUIDOS
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-22">
            Y además te llevás{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-23">
              5 bonus exclusivos
            </span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-5 mb-5" data-id="element-24">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.07,
          duration: 0.5
        }} className="bg-white border border-line rounded-3xl p-6 md:p-7 shadow-sm flex flex-col" data-id="element-25">
              <div className="flex items-start gap-4 mb-4" data-id="element-26">
                <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-rose/10 flex items-center justify-center" data-id="element-27">
                  <b.icon className="w-6 h-6 text-rose" data-id="element-28" />
                </div>
                <div className="flex-1" data-id="element-29">
                  <div className="text-xs font-bold text-rose tracking-widest mb-1" data-id="element-30">
                    🎁 BONO {b.n}
                  </div>
                  <h3 className="font-serif font-bold text-lg md:text-xl text-ink leading-snug uppercase" data-id="element-31">
                    {b.title}
                  </h3>
                </div>
              </div>
              <p className="text-ink-soft text-sm leading-relaxed mb-4" data-id="element-32">
                {b.desc}
              </p>
              <ul className="space-y-1.5 mb-5 flex-1" data-id="element-33">
                {b.items.map((it, j) => <li key={j} className="text-sm text-ink-soft flex items-center gap-2" data-id="element-34">
                    <span className="text-rose" data-id="element-35">🌸</span>
                    {it}
                  </li>)}
              </ul>
              <div className="flex items-baseline gap-3 pt-4 border-t border-line" data-id="element-36">
                <span className="text-muted line-through text-base" data-id="element-37">
                  {b.price}
                </span>
                <span className="bg-rose text-white text-xs font-black px-3 py-1 rounded-full" data-id="element-38">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Premium */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-ink text-white rounded-3xl p-7 md:p-10 overflow-hidden" data-id="element-39">
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-rose/25 blur-3xl rounded-full" data-id="element-40" />
          <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-gold/15 blur-3xl rounded-full" data-id="element-41" />

          <div className="relative" data-id="element-42">
            <div className="flex items-start gap-4 mb-5" data-id="element-43">
              <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-rose flex items-center justify-center shadow-lg shadow-rose/30" data-id="element-44">
                <premium.icon className="w-7 h-7 text-white" data-id="element-45" />
              </div>
              <div data-id="element-46">
                <div className="text-xs font-bold text-gold tracking-widest mb-1" data-id="element-47">
                  🔥 BONUS PREMIUM
                </div>
                <h3 className="font-serif font-bold text-2xl md:text-3xl text-white leading-tight uppercase" data-id="element-48">
                  {premium.title}
                </h3>
              </div>
            </div>
            <p className="text-white/80 text-base leading-relaxed mb-5 max-w-3xl" data-id="element-49">
              {premium.desc}
            </p>
            <div className="flex flex-wrap gap-2 mb-6" data-id="element-50">
              {premium.items.map((it, j) => <span key={j} className="bg-white/10 border border-white/15 text-sm text-white/90 px-3 py-1.5 rounded-full capitalize" data-id="element-51">
                  🌸 {it}
                </span>)}
            </div>
            <div className="flex items-baseline gap-3 pt-5 border-t border-white/15" data-id="element-52">
              <span className="text-white/50 line-through text-base" data-id="element-53">
                {premium.price}
              </span>
              <span className="bg-rose text-white text-xs font-black px-3 py-1 rounded-full" data-id="element-54">
                GRATIS
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mt-8" data-id="element-55">
          <p className="font-serif-italic text-rose text-lg md:text-2xl" data-id="element-56">
            Valor total de bonus: <span className="line-through" data-id="element-57">$46.000</span>{' '}
            →{' '}
            <strong className="not-italic text-ink font-serif font-bold" data-id="element-58">
              GRATIS
            </strong>{' '}
            con tu ebook
          </p>
        </motion.div>
      </div>
    </section>;
}